module.exports = __webpack_public_path__ + "static/img/invest-make6.e54eeef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/investCase/invest-make6.jpg
// module id = SJeL
// module chunks = 0